module.exports = __webpack_public_path__ + "img/thumb_31.84dfe1c0.jpg";